import { BusinessHealthResponse } from '../../types';

const isComponentIncluded = (
    componentKey: string,
    data?: BusinessHealthResponse,
) => Boolean(data?.healthscore?.components?.[componentKey]?.included);

export default isComponentIncluded;
